import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { UserRef } from 'src/typings';

@Component({
  selector: 'app-user-selector',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  constructor(private userService: UserService) {}

  users: Observable<UserRef[]> = this.userService.getRefListUsers(true);

  filteredOptions: Observable<Observable<UserRef[]>> = new Observable<Observable<UserRef[]>>();

  @Input() control: UntypedFormControl = new UntypedFormControl('');

  public displayProperty(user: UserRef | null): string {
    return user?.name || '';
  }

  ngOnInit(): void {
    this.filteredOptions = this.control.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }

  private _filter(value: string | UserRef): Observable<UserRef[]> {
    const lowerValue = typeof value === 'string' ? value.toLowerCase() : value?.name.toLowerCase();

    return this.users.pipe(
      map((users) =>
        users.filter((user) => {
          if (!lowerValue) return true;
          return user.name.toLowerCase().includes(lowerValue);
        })
      )
    );
  }
}
